import React from 'react';

import { PieChart } from '~components/visualisation';

export interface CategoryDatum {
  label: string;
  value: number;
  color: string;
}

interface ComponentProps {
  title: string;
  data: CategoryDatum[];
  color: string;
  showTotal?: boolean;
  utilisation?: number;
  catergoryTotal?: number;
}

export const Category: React.FC<ComponentProps> = ({ title, data, showTotal, catergoryTotal, color, utilisation }) => {
  // Don't render if there's no data or all values are 0
  const hasData = data && data.length > 0 && data.some((item) => item.value > 0);
  const hasTotal = catergoryTotal && catergoryTotal > 0;

  // For categories with totals, don't render if total is 0 or no data
  if (showTotal && (!hasTotal || !hasData)) {
    return null;
  }

  // For allocation charts, don't render if no data
  if (!showTotal && !hasData) {
    return null;
  }

  return (
    <div className="category-container">
      <div className="category-pie-wrapper">
        <PieChart
          title={
            <h2 className="category-title" style={{ color }}>
              {title}
            </h2>
          }
          showLegend={true}
          data={data.map(({ label, value, color }) => ({ id: label, label, value, color }))}
          arcLabelFormat="percentage"
          tooltipFormat="dollars"
          height={250}
          width={300}
          responsive={false}
          totals={
            showTotal && (
              <div className="category-totals">
                <div className="category-total">Total: ${catergoryTotal?.toLocaleString() ?? 0}</div>
                <div className="category-utilisation">Utilisation: {utilisation?.toFixed(1) ?? 0}%</div>
              </div>
            )
          }
        />
      </div>
    </div>
  );
};
